import React from 'react';


const CellPhoneIcon = (props) => {

  return (
    <svg width={props.width || "24"} height={props.height || "24"} viewBox="0 0 24 24" fill={props.fill || "none"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.4763 16.1464L16.0826 14.9339C16.5063 14.7164 16.9426 14.6639 17.2076 14.8252C17.6063 15.0752 20.9576 17.3102 21.2363 17.5089C21.5151 17.7077 21.6476 18.2702 21.2526 18.8177C20.8576 19.3652 19.0413 21.5289 18.2813 21.5002C17.5213 21.4714 14.3576 21.3752 8.45509 15.4414C2.55259 9.50769 2.51634 6.37519 2.50009 5.62519C2.48384 4.87519 4.70259 3.11019 5.26259 2.73019C5.82259 2.35019 6.38759 2.49769 6.58634 2.76894C6.80759 3.07769 8.98884 6.41519 9.22884 6.79769C9.39259 7.05894 9.32759 7.49269 9.10384 7.90769C8.88009 8.32269 7.93759 9.90769 7.93759 9.90769C7.93759 9.90769 8.57259 11.0164 10.7501 13.2089C11.7876 14.2714 14.4763 16.1464 14.4763 16.1464Z" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default CellPhoneIcon
